import { Layout } from '@/modules/shared/layouts/layout'

import { useCustomerSearch } from '../hooks/use-customer-search.hook'
import { CustomerSearchInterface } from '../interfaces/customer-search.interface'

export function CustomerSearchContainer() {
  const clientSearch = useCustomerSearch()

  return (
    <Layout pageTitle="Clientes" handleGoBack={clientSearch.handleBackPage}>
      <CustomerSearchInterface {...clientSearch} />
    </Layout>
  )
}
